import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { SUPER_USER } from '../../actionTypes/Users/UserActionType';
import BannersCurrent from './banners/BannersCurrent';
import { setPageTitle } from '../../actions/Page/PageAction';

const NotificationsDashboard = () => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.AppSession);

  useEffect(() => {
    dispatch(setNavigateToMsg('Message Users'));
    dispatch(setPageTitle('Message Users'));
    return () => {
      dispatch(setPageTitle());
    };
  }, []);

  return userDetails.userRole === SUPER_USER ? (
    <div tabIndex="-1" id={'notificationsDashboard'} className={'notifications-dashboard init-focus__hidden'}>
      <div className="md-title">
        <h1 className="form-title-center" id="app_page_title">
          Message Users
        </h1>
      </div>
      <BannersCurrent />
    </div>
  ) : null;
};

export default NotificationsDashboard;
